import { navigationSnapshotSchema, type NavigationSnapshot } from './navigationContract'

export async function fetchNavigationSnapshot(): Promise<NavigationSnapshot> {
  const response = await fetch('/api/navigation', {
    cache: 'no-store',
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  })
  const payload = (await response.json().catch(() => null)) as unknown
  if (!response.ok || !payload || typeof payload !== 'object') {
    throw new Error('Navigation data is temporarily unavailable.')
  }

  const body = payload as { data?: unknown; success?: unknown }
  const parsed = navigationSnapshotSchema.safeParse(body.data)
  if (body.success !== true || !parsed.success) {
    throw new Error('Navigation data is temporarily unavailable.')
  }
  return parsed.data
}
